import {
  ArchiveOutlined,
  AudioFileOutlined,
  CodeOutlined,
  DataObjectOutlined,
  DescriptionOutlined,
  FolderOutlined,
  ImageOutlined,
  InsertDriveFileOutlined,
  PictureAsPdfOutlined,
  TableChartOutlined,
  VideoLibraryOutlined,
} from '@mui/icons-material'
import React from 'react'

type IconComponent = React.ComponentType<any>

const EXTENSION_ICON_MAP: Record<string, IconComponent> = {
  // Documents
  pdf: PictureAsPdfOutlined,
  doc: DescriptionOutlined,
  docx: DescriptionOutlined,
  txt: DescriptionOutlined,
  rtf: DescriptionOutlined,
  odt: DescriptionOutlined,

  // Spreadsheets
  xls: TableChartOutlined,
  xlsx: TableChartOutlined,
  csv: TableChartOutlined,
  ods: TableChartOutlined,

  // Code
  js: CodeOutlined,
  ts: CodeOutlined,
  tsx: CodeOutlined,
  jsx: CodeOutlined,
  py: CodeOutlined,
  java: CodeOutlined,
  cpp: CodeOutlined,
  c: CodeOutlined,
  html: CodeOutlined,
  css: CodeOutlined,
  json: DataObjectOutlined,
  xml: CodeOutlined,
  yaml: CodeOutlined,
  yml: CodeOutlined,
  sql: DataObjectOutlined,

  // Images
  jpg: ImageOutlined,
  jpeg: ImageOutlined,
  png: ImageOutlined,
  gif: ImageOutlined,
  svg: ImageOutlined,
  bmp: ImageOutlined,
  webp: ImageOutlined,
  ico: ImageOutlined,

  // Videos
  mp4: VideoLibraryOutlined,
  avi: VideoLibraryOutlined,
  mov: VideoLibraryOutlined,
  mkv: VideoLibraryOutlined,
  flv: VideoLibraryOutlined,
  wmv: VideoLibraryOutlined,
  webm: VideoLibraryOutlined,

  // Audio
  mp3: AudioFileOutlined,
  wav: AudioFileOutlined,
  flac: AudioFileOutlined,
  aac: AudioFileOutlined,
  ogg: AudioFileOutlined,
  m4a: AudioFileOutlined,

  // Archives
  zip: ArchiveOutlined,
  rar: ArchiveOutlined,
  '7z': ArchiveOutlined,
  tar: ArchiveOutlined,
  gz: ArchiveOutlined,
  bz2: ArchiveOutlined,

  // Folders
  folder: FolderOutlined,
}

/**
 * Get the Material-UI icon component for a file extension
 * @param extension - File extension (with or without dot)
 * @returns React component for the icon
 */
export function getFileIcon(extension: string): IconComponent {
  // Normalize: remove leading dot and convert to lowercase
  const normalized = extension.replace(/^\./, '').toLowerCase()

  return EXTENSION_ICON_MAP[normalized] || InsertDriveFileOutlined
}

/**
 * Alternative version that returns icon props for rendering
 * @param extension - File extension (with or without dot)
 * @param props - Additional MUI icon props
 * @returns JSX element
 */
export function FileIcon({ extension, ...props }: { extension: string; [key: string]: any }): React.ReactElement {
  const IconComponent = getFileIcon(extension)
  return <IconComponent {...props} />
}
